/**
 * Cookie consent bar — UI logic.
 *
 * Shows the consent panel if `noomaCookies` cookie is absent.
 * Handles: accept all, save preferences (both from summary and details),
 * open preferences, and close (back to summary).
 *
 * Cookie value: JSON object stored under key `noomaCookies`, valid 360 days.
 * Used by GTM / GA — do not change the cookie name or JSON key names.
 *
 * Also pushes a live `gtag('consent', 'update', ...)` on every choice so GTM/GA4
 * see the decision immediately, on the same pageview — not only on the next full
 * page load (which re-reads the `default` consent set in `layout/theme.liquid`).
 * See docs/INTERNAL.md → Cookie consent (GA4).
 */

const cookieMain = document.querySelector('[data-name="cookie-bar-main"]');
if (cookieMain) {
  const cookieSummary = document.querySelector('[data-name="cookiebar-summary"]');
  const cookieDetails = document.querySelector('[data-name="cookiebar-details"]');
  const cookieSettingsBtn = document.querySelector('[data-name="cookie-settings-btn"]');
  const cookieCloseBtn = document.querySelector('[data-name="cookie-close-btn"]');
  const cookieAcceptAllBtns = document.querySelectorAll('[data-name="cookie-accept-btn"]');
  const cookieNecessaryBtns = document.querySelectorAll('[data-name="cookie-necessary-btn"]');

  if (document.cookie.indexOf('noomaCookies=') < 0) {
    cookieMain.classList.add('ShowCookies');
  }

  const showDetails = () => {
    cookieSummary.style.display = 'none';
    cookieDetails.style.display = 'flex';
  };

  const showSummary = () => {
    cookieDetails.style.display = 'none';
    cookieSummary.style.display = '';
  };

  const cookiesCreator = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + encodeURIComponent(JSON.stringify(cvalue)) + ';' + expires + ';path=/';
  };

  const pushConsentUpdate = (prefs) => {
    const granted = (key) => (prefs[key] === 'granted' ? 'granted' : 'denied');
    window.gtag?.('consent', 'update', {
      analytics_storage: granted('analyticCookies'),
      ad_storage: granted('marketingCookies'),
      ad_user_data: granted('marketingCookies'),
      ad_personalization: granted('marketingCookies'),
      functionality_storage: granted('functionalCookies'),
      personalization_storage: granted('functionalCookies'),
      security_storage: 'granted',
    });
  };

  const acceptAllCookies = () => {
    const prefs = {
      necessaryCookies: 'granted',
      functionalCookies: 'granted',
      analyticCookies: 'granted',
      marketingCookies: 'granted',
    };
    cookiesCreator('noomaCookies', prefs, 360);
    pushConsentUpdate(prefs);
    cookieMain.classList.remove('ShowCookies');
  };

  const acceptNecessaryCookies = () => {
    const prefs = {
      necessaryCookies: 'granted',
      functionalCookies: document.querySelector('[data-name="functional-toggle"]')?.checked ? 'granted' : 'denied',
      analyticCookies: document.querySelector('[data-name="analytics-toggle"]')?.checked ? 'granted' : 'denied',
      marketingCookies: document.querySelector('[data-name="marketing-toggle"]')?.checked ? 'granted' : 'denied',
    };
    cookiesCreator('noomaCookies', prefs, 360);
    pushConsentUpdate(prefs);
    cookieMain.classList.remove('ShowCookies');
  };

  if (cookieSettingsBtn) {
    cookieSettingsBtn.addEventListener('click', showDetails);
  }

  if (cookieCloseBtn) {
    cookieCloseBtn.addEventListener('click', showSummary);
  }

  for (const btn of cookieAcceptAllBtns) {
    btn.addEventListener('click', acceptAllCookies);
  }

  for (const btn of cookieNecessaryBtns) {
    btn.addEventListener('click', acceptNecessaryCookies);
  }
}
